module.exports = __webpack_public_path__ + "static/media/monitoraggio.595a2bf8.md";